<main class="merchandise_list">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_(app.query.category)}}</h1>
            <span
                class="icon back"
                @click="app.setPage('MerchandiseCategories')"
            >
                chevron_left
            </span>
        </div>
    </header>

    <section>
        <merchandise-carousel
            :hasArrowButton="true"
            :images="pickedUpImages"
            :clickable="true"
            :lang="app.getLang()"
            v-if="pickedUpImages.length"
            @setMerchandiseItem="setMerchandiseItem"
        >
        </merchandise-carousel>

        <span before-icon="view_module" class="title"
            >{{_('merchandise_list')}}</span
        >
        <div class="merchandises">
            <merchandise-item-card
                v-for="(merchandise_item, key) in merchandise_items"
                :key="key"
                :merchandiseItem="merchandise_item"
                :amount="merchandise_item.amountIncludingTax()"
                :lang="app.getLang()"
                :clickable="true"
                @setMerchandiseItem="setMerchandiseItem"
            ></merchandise-item-card>
        </div>
    </section>
    <tab-bar :page="app.query.page"></tab-bar>
</main>
